var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgrammingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 913,
    width: 144,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-105 -913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.885 1009.61 139.755 992.5 156.885 975.385 161.115 979.615 148.245 992.5 161.115 1005.39 156.885 1009.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.115 1009.61 192.885 1005.39 205.755 992.5 192.885 979.615 197.115 975.385 214.245 992.5 197.115 1009.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.952 1009.48 181.303 974.854 186.846 977.151 172.495 1011.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 938.5 117 1031.5 237 1031.5 237 938.5ZM220.5 947.5C222.157 947.5 223.5 948.843 223.5 950.5 223.5 952.157 222.157 953.5 220.5 953.5 218.843 953.5 217.5 952.157 217.5 950.5 217.5 948.843 218.843 947.5 220.5 947.5ZM210 947.5C211.657 947.5 213 948.843 213 950.5 213 952.157 211.657 953.5 210 953.5 208.343 953.5 207 952.157 207 950.5 207 948.843 208.343 947.5 210 947.5ZM199.5 947.5C201.157 947.5 202.5 948.843 202.5 950.5 202.5 952.157 201.157 953.5 199.5 953.5 197.843 953.5 196.5 952.157 196.5 950.5 196.5 948.843 197.843 947.5 199.5 947.5ZM228 1022.5 126 1022.5 126 962.5 228 962.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingIcon);
export default __webpack_public_path__ + "static/media/programmingIcon.81e30e095e33bb2efb9c53dd3143d43a.svg";
export { ForwardRef as ReactComponent };